import Add from '@mui/icons-material/Add';
import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';

const thumbsContainer: any = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  width: '100%',
  height: '100%',
};

const thumb: any = {
  position: 'relative',
  display: 'inline-flex',
  width: '100%',
  height: '100%',
  boxSizing: 'border-box',
};

const thumbInner = {
  width: '100%',
  height: '100%',
  minWidth: 0,
  overflow: 'hidden',
};

const img: any = {
  display: 'block',
  objectFit: 'cover',
  width: '100%',
  height: '100%',
  borderRadius: '0',
};

const ImgageAreaBox = styled(Button)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(255,255,255,0.09803921568627451 )',
  borderRadius: '0',
  border: 'solid',
  borderColor: '#ffffff',
  borderWidth: '1px',
  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.09803921568627451 )',
  },
  width: '100%',
  height: '100%',
}));

const MainBox = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  right: 0,
}));

function UserDropZoneCards(props: any) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [files, setFiles] = useState<any[]>([]);
  const [image, setImage] = useState(props.image);

  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/png,image/jpeg',
    onDrop: acceptedFiles => {
      setIsLoaded(true);
      setFiles(
        acceptedFiles.map(file =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
    useFsAccessApi: false,
  });

  useEffect(() => {
    setImage(props.image);
  }, [props]);

  const thumbs = files.map((file, index) => (
    <div style={thumb} key={index}>
      <div style={thumbInner}>
        <img src={image || file.preview} style={img} alt="" />
        {props.SetHeader(file.preview)}
        {props.setImage(file)}
      </div>
    </div>
  ));

  useEffect(
    () => () => {
      // files.forEach((file) => URL.revokeObjectURL(file.preview));
      // for (let i = 0; i < files.length; i++) {
      //     const file = files[i];
      //     console.log(file)
      //     if (file.preview && file.preview !== ""){
      //         props.SetHeader(file.preview);
      //     }
      // }
    },
    // eslint-disable-next-line
    [files]
  );

  return (
    <MainBox className="container">
      <div
        {...getRootProps({ className: 'dropzone' })}
        style={{ width: '100%', height: '100%', ...props?.style }}
      >
        <input {...getInputProps()} />
        {isLoaded ? (
          <aside style={thumbsContainer}>{thumbs}</aside>
        ) : (
          <ImgageAreaBox
            endIcon={
              <Add
                style={{
                  fontSize: '40px',
                  color: '#36899f',
                  position: 'absolute',
                  left: '50%',
                  top: '50%',
                  transform: 'translate(-50%, -50%)',
                }}
              />
            }
            style={props?.style}
          />
        )}
      </div>
    </MainBox>
  );
}

export default UserDropZoneCards;
